import React, { useEffect } from 'react';
import styles from './Box.module.css';
import { HoverState } from '../../../../assets/utils/cursorTypes';

export type BoxProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    title: string;
    backgroundImage: string;
}

const getHoverContent = (title: string) => {
    switch (title.toLowerCase()) {
        case 'frontend dev':
            return `<div class="hero">\n  <p>Hello World</p>\n</div>`;
        case 'backend dev':
            return `app.get('/api', (req, res) => {\n  res.send('Backend Works');\n});`;
        case 'designer':
            return `───────\n│ UI  │\n───────\n│UX FL│`;
        default:
            return '';
    }
}

const Box = (props: BoxProps) => {

    const handleMouseEnter = () => props.setHoverElement('pointer');
    const handleMouseLeave = () => props.setHoverElement('normal');

    const hoverContent = getHoverContent(props.title);


    useEffect(() => {

    }, [hoverContent]);

    return (
        <div
            className={styles.box}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={styles.backgroundContent}>
                <pre>
                    <img src={`/images/${props.backgroundImage}`} alt={`${props.title}`} className={styles.box_image} />
                </pre>
            </div>
            <span className={styles.box_title}>{props.title}</span>
        </div>
    )
}

export default Box;
